import script from "./MFAChallenge.vue?vue&type=script&setup=true&lang=js"
export * from "./MFAChallenge.vue?vue&type=script&setup=true&lang=js"

import "./MFAChallenge.vue?vue&type=style&index=0&id=5b296f6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b296f6f"]])

export default __exports__